import { Component } from '@angular/core';

@Component({
  selector: 'app-download-templates',
  templateUrl: './download-templates.component.html',
  styleUrls: ['./download-templates.component.scss']
})
export class DownloadTemplatesComponent {

}
